export const keys = {
  all: ['templates'] as const,
  clioTemplatesExist: () => [...keys.all, 'clioTemplatesExist'] as const,
};
